module.exports = __webpack_public_path__ + "img/2.d3fb6ce1.jpg";